// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const btnTop = document.getElementById("btnTop");

    window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
            btnTop.classList.add("show");
        } else {
            btnTop.classList.remove("show");
        }
    });

    btnTop.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
});




/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});



// --- Restrict scroll ---
/* document.documentElement.classList.add("no-scroll");
document.body.classList.add("no-scroll");

document.addEventListener("DOMContentLoaded", () => {

    const getOffset = (isClick = false) => {
        if (window.innerWidth < 768) {
            return isClick ? 120 : 190;
        }
        return 190;
    };

    const goToHash = (hash, smooth = true, isClick = false) => {
        if (!hash) return;
        const el = document.querySelector(hash);
        if (!el) return;

        const top = el.getBoundingClientRect().top + window.pageYOffset - getOffset(isClick);

        window.scrollTo({
            top,
            behavior: smooth ? "smooth" : "auto"
        });

        if (location.hash !== hash) {
            history.replaceState(null, null, hash);
        }
    };

    // --- click on anchor ---
    document.addEventListener("click", (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;

        // Check if it's the same page
        if (a.origin === location.origin && a.pathname === location.pathname) {
            const hash = a.hash;
            if (hash && hash !== "#" && document.querySelector(hash)) {
                e.preventDefault();
                goToHash(hash, true, true);
            }
        }
    });

    // --- after load scroll ---
    window.addEventListener("load", () => {
        document.documentElement.classList.remove("no-scroll");
        document.body.classList.remove("no-scroll");

        if (location.hash) {
            setTimeout(() => {
                goToHash(location.hash, true, false);
            }, 300);
        }
    });

    // --- popstate ---
    window.addEventListener("popstate", () => {
        if (location.hash) {
            setTimeout(() => goToHash(location.hash, true, false), 50);
        }
    });

    // --- resize ---
    let timer;
    window.addEventListener("resize", () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            if (location.hash) goToHash(location.hash, true, false);
        }, 120);
    });

}); */

//Testimonials Slider
document.addEventListener("DOMContentLoaded", function () {
    const MQ = window.matchMedia("(max-width: 768px)");

    function cfg() {
        return {
            SPACE: MQ.matches ? 30 : 30,
            EXTRA: MQ.matches ? 50 : 60,
        };
    }

    const el = document.querySelector(".testimonials-slider");
    if (!el) return;

    let { SPACE, EXTRA } = cfg();

    const swiper = new Swiper(el, {
        direction: "vertical",
        loop: true,
        slidesPerView: 2,
        spaceBetween: SPACE,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: { delay: 5000, disableOnInteraction: false },
        grabCursor: false,
        keyboard: false,
    });

    function measureCardHeight() {
        const first = el.querySelector(".swiper-slide .testimonial-item");
        if (!first) return MQ.matches ? 469 : 354;
        return Math.ceil(first.getBoundingClientRect().height);
    }

    function applyClamp(slide) {
        const body = slide.querySelector(".t-body");
        const p = body ? body.querySelector("p") : null;
        if (!body || !p) return;
        const lh = parseFloat(getComputedStyle(p).lineHeight) || 24;
        const lines = Math.max(1, Math.floor(body.clientHeight / lh));
        p.style.webkitLineClamp = String(lines);
    }

    function applyHeights() {
        ({ SPACE, EXTRA } = cfg());

        if (swiper.params.spaceBetween !== SPACE) {
            swiper.params.spaceBetween = SPACE;
            if (swiper.update) swiper.update();
        }

        const slides = Array.from(
            swiper.slides || el.querySelectorAll(".swiper-slide")
        );
        if (!slides.length) return;

        const CARD_H = measureCardHeight();
        const bottomIndex = Math.min(
            (swiper.activeIndex || 0) + 1,
            slides.length - 1
        );

        slides.forEach((s, i) => {
            const extra = i === bottomIndex && slides.length > 1 ? EXTRA : 0;
            s.style.height = CARD_H + extra + "px";
        });

        el.style.height = CARD_H * 2 + SPACE + EXTRA + "px";

        slides.forEach(applyClamp);

        swiper.updateSize && swiper.updateSize();
        swiper.updateSlides && swiper.updateSlides();
        swiper.updateAutoHeight && swiper.updateAutoHeight(0);
        swiper.updateProgress && swiper.updateProgress();
        swiper.updateSlidesClasses && swiper.updateSlidesClasses();
        if (swiper.params.autoplay && swiper.autoplay?.start)
            swiper.autoplay.start();
    }

    applyHeights();
    swiper.on && swiper.on("slideChange", applyHeights);
    window.addEventListener("resize", applyHeights);
    window.addEventListener("load", () => requestAnimationFrame(applyHeights));
    setTimeout(applyHeights, 120);

    if (MQ.addEventListener) MQ.addEventListener("change", applyHeights);
    else if (MQ.addListener) MQ.addListener(applyHeights);
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});


//sticky scroll
jQuery(function ($) {
    initStickyContent();

    function initStickyContent() {
        const $blocks = $(".sticky-scroll");
        if (!$blocks.length) return;

        $blocks.each(function () {
            const $block = $(this);
            const $items = $block.find(".section-item");
            const $media = $block.find(".section-media");
            const $row = $block.find(".sticky-content-wrapper");
            const $left = $block.find(".sticky-left-column");

            if ($items.length && $media.length) {
                $items.removeClass("active").first().addClass("active");
                $media.removeClass("active").first().addClass("active");
            }

            function applyBottomPadding() {
                if (!$left.length || !$row.length) return;

                var topPx =
                    parseInt(window.getComputedStyle($left[0]).top, 10) || 120;
                var leftH = $left.outerHeight();
                var vh =
                    window.innerHeight || document.documentElement.clientHeight;

                var extra = Math.max(0, leftH - (vh - topPx));
                $row.css("padding-bottom", extra + 32 + "px");
            }

            applyBottomPadding();
            $(window).on("load resize", applyBottomPadding);

            $block.find("img").on("load", applyBottomPadding);

            function checkFeatureVisibility() {
                if (window.innerWidth <= 767) return;

                const scrollTop = $(window).scrollTop();
                const windowHeight = $(window).height();
                const triggerLine = scrollTop + windowHeight * 0.48;

                let activeIndex = 0;
                let minDistance = Number.POSITIVE_INFINITY;

                $items.each(function (index) {
                    const $item = $(this);
                    const itemTop = $item.offset().top;
                    const itemH = $item.outerHeight();
                    const center = itemTop + itemH / 2;
                    const dist = Math.abs(triggerLine - center);

                    if (dist < minDistance) {
                        minDistance = dist;
                        activeIndex = index;
                    }
                });

                activateFeature(activeIndex);
            }

            function activateFeature(index) {
                $items.removeClass("active").eq(index).addClass("active");
                $media.removeClass("active").eq(index).addClass("active");
            }

            $(window).on("scroll", checkFeatureVisibility);
            $items.on("click", function () {
                if (window.innerWidth <= 767) return;
                const index = $(this).data("item");
                activateFeature(index);
            });

            checkFeatureVisibility();
        });
    }
});

//Slider logos
jQuery(document).ready(function ($) {
    var $slider = $(".logos-slider");
    if ($slider.length === 0) {
        return;
    }

    var $title = $(".title-content");
    var $controls = $(".slider-controls.mobile");
    
    // Save hash and prevent browser auto-scroll
    var savedHash = window.location.hash;
    if (savedHash) {
        history.replaceState(null, null, ' ');
        window.scrollTo(0, 0);
    }

    // Fix anchor scroll after Slick initialization - must be BEFORE slick()
    $slider.on('init', function() {
        if (savedHash) {
            setTimeout(function() {
                var target = $(savedHash);
                if (target.length) {
                    var headerOffset = 150;
                    var targetOffset = target.offset().top - headerOffset;
                    window.scrollTo({
                        top: targetOffset,
                        behavior: 'smooth'
                    });
                    // Restore hash without triggering scroll
                    history.replaceState(null, null, savedHash);
                }
            }, 100);
        }
        if (typeof AOS !== 'undefined') {
            AOS.refresh();
        }
    });

    $slider.slick({
        slidesToShow: 6,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        prevArrow: $(".prev-arrow"),
        nextArrow: $(".next-arrow"),
        responsive: [
            {
                breakpoint: 1400,
                settings: { slidesToShow: 5 },
            },
            {
                breakpoint: 1200,
                settings: { slidesToShow: 4 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 },
            },
        ],
    });

    function checkSlides() {
        if (!$slider.hasClass('slick-initialized')) {
            return;
        }

        var slickInstance = $slider.slick("getSlick");
        if (!slickInstance || !slickInstance.$slides) {
            return;
        }

        var totalSlides = slickInstance.$slides.length;
        var currentSlidesToShow = slickInstance.options.slidesToShow;

        if (totalSlides <= currentSlidesToShow) {
            $title.addClass("few-items");
            $controls.addClass("no-slider-controls");
        } else {
            $title.removeClass("few-items");
            $controls.removeClass("no-slider-controls");
        }
    }

    $slider.on("init setPosition", function () {
        checkSlides();
    });

    $(window).on("resize orientationchange", function () {
        if ($slider.length > 0) {
            setTimeout(checkSlides, 200);
        }
    });


    if ($slider.hasClass("slick-initialized")) {
        checkSlides();
    }
});

//latest-insights

jQuery(function ($) {
    $(".latest-insights .slider-insights").each(function () {
        var $slider = $(this);
        var $wrap = $slider.closest(".latest-insights__wrapper");
        var $ctrls = $wrap.find(".latest-slider-controls");

        function refreshAOS() {
            if (window.AOS) {
                if (typeof AOS.refreshHard === "function") AOS.refreshHard();
                else if (typeof AOS.refresh === "function") AOS.refresh();
            }
        }

        if ($slider.hasClass("slick-initialized")) $slider.slick("unslick");

        $slider.on("init reInit setPosition afterChange", refreshAOS);

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true,
            dots: false,

            prevArrow: $ctrls.find(".prev-arrow"),
            nextArrow: $ctrls.find(".next-arrow"),
            appendArrows: $ctrls,

            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 1 } },
            ],
        });

        $slider.find("img").on("load", refreshAOS);
        $(window).on("load", refreshAOS);
        setTimeout(refreshAOS, 600);
    });
});

//Related Insights
jQuery(document).ready(function ($) {
    var $slider = $(".related-insights .slider-related-insights");
    $slider.slick({
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        prevArrow: $(".prev-arrow"),
        nextArrow: $(".next-arrow"),
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
    $slider.on("init", function () {
        AOS.refresh();
    });

    $slider.on("setPosition", function () {
        AOS.refresh();
    });
});

// Animated Cards

jQuery(document).ready(function ($) {
    "use strict";

    const $cardsWrapper = $(".animated-cards .cards-wrapper");
    const $animatedCards = $cardsWrapper.find(".animated-card");
    if (!$animatedCards.length) return;

    // Remove all active states initially - cards start collapsed
    $animatedCards.removeClass("is-active");

    // Handle hover - add class to container and manage card expansion
    $animatedCards.on("mouseenter", function () {
        if (window.innerWidth > 992) {
            const cardIndex = $(this).data("card-index");

            $cardsWrapper.addClass("has-hover");
            $(this).addClass("is-active");

            // Add specific class based on which card is hovered
            if (cardIndex === 1) {
                $cardsWrapper.addClass("card-2-expanded");
            } else if (cardIndex === 2) {
                $cardsWrapper.addClass("card-3-expanded");
            }
        }
    });

    $animatedCards.on("mouseleave", function () {
        if (window.innerWidth > 992) {
            $(this).removeClass("is-active");
            $cardsWrapper.removeClass("has-hover card-2-expanded card-3-expanded");
        }
    });

    // Handle window resize - remove states on mobile
    const handleResize = () => {
        if (window.innerWidth <= 992) {
            $animatedCards.removeClass("is-active");
            $cardsWrapper.removeClass("has-hover card-2-expanded card-3-expanded");
        }
    };

    $(window).on("resize", handleResize);
});

// Refresh AOS
jQuery(window).on("load", function () {
    if (typeof AOS !== "undefined") {
        AOS.refresh();
        setTimeout(() => AOS.refresh(), 800);
    }
});

// Lenis Smooth Scroll
// document.addEventListener("DOMContentLoaded", function () {
//     // Initialize Lenis
//     const lenis = new Lenis({
//         autoRaf: true,
//     });

//     // Listen for the scroll event and log the event data
//     lenis.on("scroll", (e) => {
//         console.log(e);
//     });
// });

// Share Button socials
document.addEventListener("DOMContentLoaded", () => {
    const shareBtn = document.querySelector(".share-button");
    const social = shareBtn?.querySelector(".social-share");
    if (!social) return;

    social.style.display = "none";
    shareBtn.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        social.style.display =
            social.style.display === "none" ? "block" : "none";
    });
    document.addEventListener(
        "click",
        (e) => !shareBtn.contains(e.target) && (social.style.display = "none")
    );
});

// Listing Slider related posts
jQuery(document).ready(function ($) {
    const $container = $(".listing-related__grid.listing-slider");
    if (!$container.length) return;

    $container.slick({
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        prevArrow: $(".prev-arrow"),
        nextArrow: $(".next-arrow"),
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 676,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    if (typeof AOS !== "undefined") {
        AOS.refresh();
    }
});

// Refresh AOS on Search and Filter Shortcode
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const placeholders = document.querySelectorAll("option.gf_placeholder");
    placeholders.forEach((option) => {
        option.disabled = true;
    });
});

// Sticky Scroll Section Media

document.addEventListener("DOMContentLoaded", function () {
    const sectionMedias = document.querySelectorAll(
        ".sticky-left-column .section-media img"
    );

    sectionMedias.forEach((img) => {
        const preload = new Image();
        preload.src = img.src;
    });

    const sectionItems = document.querySelectorAll(
        ".sticky-right-column .section-item"
    );
    const leftMedias = document.querySelectorAll(
        ".sticky-left-column .section-media"
    );

    let activeIndex = 0;
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const newIndex = parseInt(entry.target.dataset.item);

                    if (newIndex !== activeIndex) {
                        leftMedias[activeIndex].classList.remove("active");
                        leftMedias[newIndex].classList.add("active");
                        activeIndex = newIndex;
                    }
                }
            });
        },
        {
            rootMargin: "0px 0px -20% 0px",
            threshold: 0.5,
        }
    );

    sectionItems.forEach((item) => observer.observe(item));
});
// FAQ Accordion Scroll Adjustment
jQuery(function ($) {
    $(".faqs__wrapper").each(function () {
        $(document).on(
            "shown.bs.collapse hidden.bs.collapse",
            ".faqs__wrapper #faqAccordion .collapse",
            function () {
                if (typeof AOS !== "undefined") {
                    if (typeof AOS.refresh === "function") {
                        AOS.refresh();
                    } else if (typeof AOS.refreshHard === "function") {
                        AOS.refreshHard();
                    }
                }
            }
        );
    });
});
/**
 * Fix scroll behavior for Search & Filter dropdowns
 */
(function () {
    "use strict";

    // Function to enable scroll on dropdown
    function enableDropdownScroll() {
        // Wait for dropdowns to be rendered
        const dropdowns = document.querySelectorAll(
            ".search-filter-component-popup, .search-filter-component-combobox-base__listbox"
        );

        dropdowns.forEach(function (dropdown) {
            // Prevent scroll propagation to parent
            dropdown.addEventListener(
                "wheel",
                function (e) {
                    const scrollTop = dropdown.scrollTop;
                    const scrollHeight = dropdown.scrollHeight;
                    const height = dropdown.clientHeight;
                    const delta = e.deltaY;
                    const up = delta < 0;

                    // Prevent default scroll if we're at the boundaries
                    if (!up && delta + scrollTop >= scrollHeight - height) {
                        dropdown.scrollTop = scrollHeight;
                        e.preventDefault();
                        e.stopPropagation();
                    } else if (up && delta + scrollTop <= 0) {
                        dropdown.scrollTop = 0;
                        e.preventDefault();
                        e.stopPropagation();
                    } else {
                        e.stopPropagation();
                    }
                },
                { passive: false }
            );

            // Prevent touch scroll propagation
            dropdown.addEventListener(
                "touchmove",
                function (e) {
                    e.stopPropagation();
                },
                { passive: true }
            );
        });
    }

    // Run when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", enableDropdownScroll);
    } else {
        enableDropdownScroll();
    }

    // Also run when filters are updated (in case they're dynamically rendered)
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length) {
                enableDropdownScroll();
            }
        });
    });

    // Start observing the document for added nodes
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
})();

/**
 * Slider Brokers gallery
 */
document.addEventListener("DOMContentLoaded", function () {
    const sliderContainer = document.querySelector(".brokers-gallery");

    if (!sliderContainer) {
        return;
    }

    const slideItems = sliderContainer.querySelectorAll(".swiper-slide");
    const controls = document.querySelector(".brokers-slider-controls");

    if (slideItems.length > 2) {
        new Swiper(sliderContainer, {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: ".brokers-button-next",
                prevEl: ".brokers-button-prev",
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 2 },
            },
        });

        if (controls) {
            controls.style.display = "flex";
        }
    } else {
        sliderContainer.classList.remove("swiper");
    }
});

// Auto-resizing Textareas

document.querySelectorAll("textarea").forEach((el) => {
    const computed = window.getComputedStyle(el);
    const minHeight = parseFloat(computed.minHeight) || 0;

    el.style.overflow = "hidden";
    el.style.transition = "height 0.2s ease";
    el.style.setProperty("height", minHeight + "px", "important");

    const adjustHeight = (target) => {
        target.style.setProperty("height", "auto", "important");

        const newHeight = Math.max(
            target.scrollHeight -
            parseFloat(computed.paddingTop) -
            parseFloat(computed.paddingBottom),
            minHeight
        );

        target.style.setProperty("height", newHeight + "px", "important");
    };

    el.addEventListener("input", (e) => adjustHeight(e.target));

    adjustHeight(el);
});


